export default {
  'analysisDetail.versionResolver.errorTitle': 'Could not load analysis.',
  'analysisDetail.versionResolver.errorBody': 'The analysis could not be resolved.',
  'analysisDetail.versionResolver.backToProjects': 'Back to projects',

  'analysisDetail.fallbackTitle': 'Analysis',

  'analysisDetail.meta.typeLabel': 'Type:',
  'analysisDetail.meta.typeValue': 'Analysis',
  'analysisDetail.meta.datasetLabel': 'Dataset:',
  'analysisDetail.meta.ownerLabel': 'Owner:',
  'analysisDetail.meta.lastModifiedLabel': 'Last modified:',

  'analysisDetail.sourceCohort.label': 'Cohort',
  'analysisDetail.sourceCohorts.title': 'Cohorts',
  'analysisDetail.sourceCohorts.collapse': 'Collapse',
  'analysisDetail.sourceCohorts.expand': 'Expand',
  'analysisDetail.sourceCohort.addButton': 'Add cohort',
  'analysisDetail.sourceCohort.switchButton': 'Switch cohort',
  'analysisDetail.sourceCohort.notSelected': 'Not yet defined',
  // Same wording as the analytical dataset page. It names variables only: the check behind it does not see a changed
  // concept group or a changed cohort definition.
  'analysisDetail.sourceCohort.staleWarning':
    'One or more analytical variables used in this cohort have changed since it was last processed. Reprocess to update your results.',

  'analysisDetail.addCohortModal.addTitle': 'Add cohort',
  'analysisDetail.addCohortModal.selectHeading': 'Select a cohort ({count})',
  'analysisDetail.addCohortModal.searchPlaceholder': 'Search cohorts…',
  'analysisDetail.addCohortModal.empty': 'No cohorts available in this project.',
  'analysisDetail.addCohortModal.noResults': 'No cohorts match your search.',
  'analysisDetail.addCohortModal.subjects':
    '{count, plural, =0 {No subjects} other {{count, number} subjects}}',
  'analysisDetail.addCohortModal.addConfirm': 'Add',
  'analysisDetail.addCohortModal.cancel': 'Cancel',

  'analysisDetail.stagedChanges.unsaved': 'Unsaved changes',
  'analysisDetail.stagedChanges.revert': 'Revert',
  'analysisDetail.stagedChanges.save': 'Save',

  'analysisDetail.saveModal.title': 'Saving analysis',
  'analysisDetail.saveModal.loadingTitle': 'Saving changes',
  'analysisDetail.saveModal.loadingText':
    'Saving the latest analysis definition. Do not close this window.',
  'analysisDetail.saveModal.errorTitle': 'Save failed',
  'analysisDetail.saveModal.errorText': 'The analysis could not be saved. Please try again.',
  'analysisDetail.saveModal.retryButton': 'Retry',

  'analysisDetail.revertModal.title': 'Reverting changes',
  'analysisDetail.revertModal.loadingTitle': 'Reverting changes',
  'analysisDetail.revertModal.loadingText': 'Restoring the analysis to its last saved state.',

  'analysisDetail.editLock.processing': 'Editing is disabled while the analysis is processing.',
  'analysisDetail.editLock.notOwner': 'Only the owner can edit this analysis.',

  'analysisDetail.studyPeriod.label': 'Study period',
  'analysisDetail.studyPeriod.notDefined': 'Not yet defined',

  'analysisDetail.tables.emptyTitle': 'No tables yet',
  'analysisDetail.tables.emptyBody':
    'Tables are built once you add a source cohort and the Research Assistant defines the analysis.',
  'analysisDetail.tables.stale.withReasons': 'These results are out of date because:',
  'analysisDetail.tables.stale.fallback':
    'These results are out of date. Process the analysis again to refresh them.',
  'analysisDetail.tables.analyticalDataset': 'Analytical dataset',
  'analysisDetail.tables.variables': 'Variables',
  'analysisDetail.tables.rowCount': '{count, plural, one {# row} other {# rows}}',
  'analysisDetail.tables.variableCount': '{count, plural, one {# variable} other {# variables}}',
  'analysisDetail.tables.preview.noRows': 'No rows defined',
  'analysisDetail.tables.preview.addVariable': 'Add variable',
  'analysisDetail.tables.preview.listView': 'List',
  'analysisDetail.tables.preview.tableView': 'Table',
  'analysisDetail.tables.preview.datasetEmptyHint':
    'Patient rows appear here after the analysis is processed.',
  'analysisDetail.tables.preview.resultsColumnPending': 'Not processed',
  'analysisDetail.addVariableModal.addTitle': 'Add variable',
  'analysisDetail.addVariableModal.selectHeading': 'Select a variable ({count})',
  'analysisDetail.addVariableModal.searchPlaceholder': 'Search variables…',
  'analysisDetail.addVariableModal.empty': 'No variables available in this project.',
  'analysisDetail.addVariableModal.noResults': 'No variables match your search.',
  'analysisDetail.addVariableModal.addConfirm': 'Add',
  'analysisDetail.addVariableModal.cancel': 'Cancel',
  'analysisDetail.tables.preview.sqlHash': 'SQL hash: {sqlHash}',
  'analysisDetail.tables.preview.sqlHashPending': 'SQL not yet generated',
  'analysisDetail.tables.preview.defaultPatientId.name': 'Patient ID',
  'analysisDetail.tables.preview.defaultPatientId.description':
    'Unique patient identifier used for linking records across data sources',
  'analysisDetail.tables.preview.defaultIndexDate.name': 'Index date',
  'analysisDetail.tables.preview.defaultIndexDate.description':
    'The qualifying date that defines cohort entry for each patient',
  'analysisDetail.tables.preview.variableList.column.number': '#',
  'analysisDetail.tables.preview.variableList.column.variable': 'Variable',
  'analysisDetail.tables.preview.variableList.column.usedIn': 'Used in',
  'analysisDetail.tables.preview.variableList.column.format': 'Format',
  'analysisDetail.tables.preview.legend.label': 'STATUS',
  'analysisDetail.tables.preview.legend.used': 'In a table',
  'analysisDetail.tables.preview.legend.intent': 'To be created',
  'analysisDetail.tables.preview.legend.unused': 'Not in a table',
  'analysisDetail.tables.preview.legend.default': 'Default variable',
  'analysisDetail.tables.preview.variableCard.delete': 'Remove variable',
  'analysisDetail.tables.preview.variableCard.reorder': 'Drag to reorder variable',
  'analysisDetail.tables.preview.variableCard.chip.default': 'Default',
  'analysisDetail.tables.preview.variableCard.chip.notUsed': 'Not used in a table',
  'analysisDetail.tables.preview.variableCard.chip.table': 'Table {number}',
  'analysisDetail.tables.preview.variableRow.noExistingVariable': 'No existing variable',
  'analysisDetail.tables.fallbackName': 'Table {number}',
  'analysisDetail.tables.grid.characteristicLabel': 'Characteristic',
  'analysisDetail.tables.grid.overallLabel': 'Overall',

  'analysisDetail.processButton': 'Process',
  'analysisDetail.processTooltip.processing': 'This analysis is already processing.',
  'analysisDetail.processTooltip.notOwner': 'Only the owner can process this analysis.',
  'analysisDetail.processTooltip.raWorking': 'Waiting for Research Assistant...',
  'analysisDetail.processTooltip.stagedChanges':
    'Save or revert your changes before processing — only the saved version is processed.',
  'analysisDetail.processTooltip.blockersTitle': 'This analysis is not ready to process:',
  'analysisDetail.processError':
    'The analysis could not be processed. Check that every source is resolved and every cohort is processed, then try again.',
  'analysisDetail.processingOverdue.message':
    'This analysis is taking longer than expected to process. Its status and results are no longer updating automatically.',
  'analysisDetail.processingOverdue.checkAgain': 'Check again',
  'analysisDetail.tables.sql.open': 'View table row SQL',
  'analysisDetail.tables.sql.close': 'Close',
  'analysisDetail.tables.sql.heading': 'SQL',
  'analysisDetail.tables.sql.columns': 'Columns',
  'analysisDetail.tables.sql.rows': 'Rows',
  'analysisDetail.tables.sql.copy': 'Copy SQL',
  'analysisDetail.tables.sql.copied': 'Copied',
  'analysisDetail.tables.selector.previous': 'Previous table',
  'analysisDetail.tables.selector.next': 'Next table',
  'analysisDetail.tables.processing.datasets': 'Preparing the analytical dataset…',
  'analysisDetail.tables.processing.cells': 'Computing the tables…',

  'analysisList.actionMenu.rename.label': 'Rename analysis',
  'analysisList.actionMenu.delete.label': 'Delete analysis',
  'analysisList.actionMenu.delete.inProgress': 'Cannot delete while analysis is running.',

  'analysisList.renameModal.title': 'Rename analysis',
  'analysisList.renameModal.name.label': 'Analysis name',
  'analysisList.renameModal.name.placeholder': 'Enter an analysis name',
  'analysisList.renameModal.maxCharacterErrorMsg': 'Name must be 100 characters or fewer.',
  'analysisList.renameModal.renameButton': 'Rename analysis',
  'analysisList.renameModal.cancelButton': 'Cancel',
  'analysisList.renameModal.closeButton': 'Close',
  'analysisList.renameModal.submitting': 'Renaming analysis',
  'analysisList.renameModal.submittingError': 'Error renaming analysis',
  'analysisList.renameModal.success.title': 'Success',
  'analysisList.renameModal.success.text': '“{name}” was renamed successfully.',

  'analysisList.deleteModal.title': 'Delete analysis',
  'analysisList.deleteModal.confirmTitle': 'Delete analysis',
  'analysisList.deleteModal.actionUndone': 'This action cannot be undone.',
  'analysisList.deleteModal.description':
    '“{name}” and all its version history and results will be permanently deleted.',
  'analysisList.deleteModal.deleteButton': 'Delete analysis',
  'analysisList.deleteModal.cancelButton': 'Cancel',
  'analysisList.deleteModal.closeButton': 'Close',
  'analysisList.deleteModal.submitting': 'Deleting analysis',
  'analysisList.deleteModal.submittingError': 'Error deleting analysis',
  'analysisList.deleteModal.success.title': 'Success',
  'analysisList.deleteModal.success.text': '“{name}” was deleted successfully.',
};
